export default function If({ otherwise, children, statement }) {
    if (statement) {
        return children(statement);
    } else {
        return otherwise || null;
    }
}
